import { CoreCsvUploadType } from '@repo/csv'

export const OPERATIONS_UPLOAD_TYPES: CoreCsvUploadType[] = ['suspend-order-submission'] as const
